<template>
    <div class="flex flex-col gap-3 p-3 border-t-4 border-transparent bg-black opacity-50 min-w-0">
        <SegmentPlayerCard :player="player" :is-active="false" :is-next="isNext" />
        <div class="flex items-center justify-between gap-5">
            <div class="flex flex-col leading-tight" v-if="!hideTarget">
                <span class="text-2xl font-bold text-white" >{{ targetLabel }}</span>
            </div>
            <!-- Points mode mirrors the active grid player: bar when there's a
                 ceiling to fill, otherwise just the running score. Race mode shows
                 segments completed / total. -->
            <SegmentsPointsProgress
                v-if="pointsMode"
                :score="score"
                :ceiling="ceiling"
                :inline="true"
                :compact="true"
                class="min-w-0 flex-1 max-w-20 "
            />
            <SegmentsCompletedCount
                v-else
                :completed="Math.min(projection.index, segments.length)"
                :total="segments.length"
                class="min-w-0 flex-1 max-w-20"
            />
        </div>
    </div>
</template>

<script>
import { DART_TYPES } from '@/constants/dartTypes.js'
import SegmentPlayerCard from '@/components/games/segments/SegmentsPlayerCard.vue'
import SegmentsCompletedCount from '@/components/games/segments/SegmentsCompletedCount.vue'
import SegmentsPointsProgress from '@/components/games/segments/SegmentsPointsProgress.vue'

export default {
    name: 'SegmentsUpcomingPlayer',
    components: {
        SegmentPlayerCard,
        SegmentsCompletedCount,
        SegmentsPointsProgress,
    },
    props: {
        player: {
            type: Object,
            required: true,
        },
        // The player's ordered segment list (from their latest turn).
        segments: {
            type: Array,
            default: () => [],
        },
        // { index, hits, target } — where the player is in their segment list.
        projection: {
            type: Object,
            default: () => ({ index: 0, hits: 0, target: null }),
        },
        hideTarget: {
            type: Boolean,
            default: false,
        },
        // Whether this is the player who throws next (first in the upcoming row).
        isNext: {
            type: Boolean,
            default: false,
        },
        // Points mode: render score/ceiling progress instead of segments completed.
        pointsMode: {
            type: Boolean,
            default: false,
        },
        // The player's running point total (points mode).
        score: {
            type: Number,
            default: 0,
        },
        // The points ceiling to fill (Ceiling mode), or null in Rounds mode.
        ceiling: {
            type: Number,
            default: null,
        },
    },
    computed: {
        targetLabel() {
            return this.segmentLabel(this.projection.target)
        },
    },
    methods: {
        segmentLabel(segment) {
            if (!segment) return '—'
            if (segment.type === DART_TYPES.BULL || segment.type === DART_TYPES.OUTER_BULL) {
                return segment.type
            }
            return `${segment.type}${segment.number}`
        },
    },
}
</script>
